<template>
  <v-chart :options="chartOp" :autoresize="true"></v-chart>
</template>

<script>
import { bm4000Line } from '@/echartOption/bm4000';

export default {
  props: {
    op: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    chartOp() {
      return bm4000Line(this.op);
    }
  }
};
</script>
